import { RiFileUploadLine, RiMapPinLine } from 'component-library';
import { TFunction } from 'i18next';

type OptionsPanelProps = {
  t: TFunction;
  onSelectManual: () => void;
  onSelectExcel: () => void;
};

export const OptionsPanel = ({ t, onSelectManual, onSelectExcel }: OptionsPanelProps) => (
  <div className='flex flex-col gap-4'>
    <button
      type='button'
      onClick={onSelectManual}
      className='flex w-full flex-col items-center gap-3 rounded-2xl border border-neutral-black-23 p-8 text-center transition-colors hover:border-primary-100 hover:bg-neutral-black-4'
    >
      <RiMapPinLine size={32} className='text-primary-100' />
      <div>
        <p className='typography-body1Semibold'>{t('shared.uploadCoordinates.addManual.title')}</p>
        <p className='typography-body2 text-text-secondary'>{t('shared.uploadCoordinates.addManual.subtitle')}</p>
      </div>
    </button>

    <button
      type='button'
      onClick={onSelectExcel}
      className='flex w-full flex-col items-center gap-3 rounded-2xl border border-neutral-black-23 p-8 text-center transition-colors hover:border-primary-100 hover:bg-neutral-black-4'
    >
      <RiFileUploadLine size={32} className='text-primary-100' />
      <div>
        <p className='typography-body1Semibold'>{t('shared.uploadCoordinates.uploadExcel.title')}</p>
        <p className='typography-body2 text-text-secondary'>{t('shared.uploadCoordinates.uploadExcel.subtitle')}</p>
      </div>
    </button>
  </div>
);
